import { IMember, IRedactedMember } from "@wingspanhq/users";

export const getNamesFromFullName = (fullName: string) => {
  const names = fullName
    .trim()
    .replace(/\s+/g, " ")
    .split(" ");

  const firstName = names[0];
  const middleName =
    names.length > 2 ? names.slice(1, names.length - 1).join(" ") : "";
  const lastName = names.length > 1 ? names[names.length - 1] : "";

  return {
    firstName,
    middleName,
    lastName
  };
};

export const getMemberCompanyName = (member: IMember | IRedactedMember) =>
  member.profile?.company?.name ||
  `${member.user.profile?.firstName} ${member.user.profile?.lastName}`;

export const getFullName = (firstName?: string, lastName?: string) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return "";
};
